/* -------------------------------------------------------------------------- */
/*                                Config                                      */
/* -------------------------------------------------------------------------- */

/**
 * Array of language objects representing language options.
 *
 * @typedef {Object} LanguageOption
 * @property {string} value - The language code.
 * @property {string} label - The label representing the language with an emoji flag.
 */

/**
 * Array containing language options.
 *
 * @type {LanguageOption[]}
 * @constant
 * @default
 */
const languages = [
	{ value: 'fr', label: 'FR' },
	{ value: 'en', label: 'EN' },
];

export default languages;
